module.exports = __webpack_public_path__ + "media/images/links_to_banks_on_success_page/Hd Bank-d2bf6874e933250a98fc27e275c47a40.png";